import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import dayjs from 'dayjs';
import { BaseComponent } from '../../../../components/BaseComponent';
import ModalComponent from '../../../../containers/App/Components/Modal/Modal';

import {
  applyTransportOrderFilters,
  createTransportOrder,
  createTransportOrderBulkAction,
  editTransportOrder,
  fetchTransportOrder,
  initiateTransportOrderCreate,
  initiateTransportOrderEdit,
  setNewTransportOrderValue,
} from '../../actions';
import { CreateFieldsColumns } from './CreateFieldsColumns';
import ButtonComponent from '../../../../containers/App/Components/Button/Button';
import { selectNewTransportOrder } from '../../selectors';
import { selectWorks } from '../../../Api/selectors';
import {
  REQUEST_CREATE_TRANSPORT_ORDER_BULK_ACTION,
  REQUEST_TRANSPORT_ORDER,
  REQUEST_TRANSPORT_ORDER_CREATE,
  REQUEST_TRANSPORT_ORDER_EDIT,
  TRANSPORT_ORDER_COLUMN_1_FIELD_TYPES,
  TRANSPORT_ORDER_COLUMN_2_FIELD_TYPES,
  TRANSPORT_ORDER_STATUS,
} from '../../constants';
import LoadingField from '../../../../containers/App/Components/LoadingField/LoadingField';
import {
  fetchVehicles,
  setNewVehicleValue,
  setVehicleProperties,
  setVehicleProperty,
} from '../../../Vehicles/actions';
import { selectNewVehicle } from '../../../Vehicles/selectors';
import { selectCompany } from '../../../Companies/selectors';
import { fetchCompany } from '../../../Companies/actions';
import { HBox, VBox } from '../../../../components/Box';
import { selectTransporters } from '../../../Transporters/selectors';
import { REQUEST_TRANSPORTER_PROPERTY_UPDATE, REQUEST_TRANSPORTERS } from '../../../Transporters/constants';
import { createTransporter, fetchTransporters } from '../../../Transporters/actions';

export const VEHICLE_EXTRA_COST = {
  incoming: 'extra_cost_transport_kosten_inkomend',
  outgoing: 'extra_cost_transport_kosten_uitgaand',
  other: 'extra_cost_transportation_costs',
};

const STATE = {};

/* eslint-disable react/prefer-stateless-function */
class CreateTransportOrderModalComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
      modaltype: 'test', // Initialize modalType state
    });
  }

  setModalToEdit = () => {
    this.setState({ modaltype: 'edit' });
  };

  componentDidMount() {
    this.props.fetchTransporters();
    if (this.props.transportOrderId) {
      this.props.fetchTransportOrder(res => {
        if (res?.id) {
          this.props.initEdit();
        }
      });
    } else {
      this.props.init();
      this.props.setValue('status', TRANSPORT_ORDER_STATUS.Requested);
    }
    if (this.props.vehicle) {
      this.props.setValue('vehicleId', this.props.vehicle?.id);
      this.props.setValue('vehicleObj', this.props.vehicle);
    }
    if (this.props.addVehicleModal) {
      const defaultAddress = this.props.homeCompany?.addresses?.find(a => a?.id == 5);
      this.props.setValue('companyTo', this.props.homeCompany);
      this.props.setValue('companyToId', this.props.homeCompany?.id);
      this.props.setValue('addressToId', defaultAddress?.id);
      this.props.setValue('addressTo', defaultAddress);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const defaultAddress = this.props.homeCompany?.addresses?.find(a => a?.id == 5);
    if (this.props.addVehicleModal && !this.props.values?.companyToId) {
      this.props.setValue('companyTo', this.props.homeCompany);
      this.props.setValue('companyToId', this.props.homeCompany?.id);
      this.props.setValue('addressToId', defaultAddress?.id);
      this.props.setValue('addressTo', defaultAddress);
    }

    if (this.props.values?.type === 'outgoing' && !this.props.values?.companyFromId) {
      this.props.setValue('companyFrom', this.props.homeCompany);
      this.props.setValue('companyFromId', this.props.homeCompany?.id);
      this.props.setValue('addressFromId', defaultAddress?.id);
      this.props.setValue('addressFrom', defaultAddress);

      if (this.props.values.companyToId === this.props.homeCompany?.id) {
        this.resetHomeCompany('to');
      }
    }
    if (this.props.values?.type === 'incoming' && !this.props.values?.companyToId) {
      this.props.setValue('companyTo', this.props.homeCompany);
      this.props.setValue('companyToId', this.props.homeCompany?.id);
      this.props.setValue('addressToId', defaultAddress?.id);
      this.props.setValue('addressTo', defaultAddress);

      if (this.props.values.companyFromId === this.props.homeCompany?.id) {
        this.resetHomeCompany('from');
      }
    }
  }

  resetHomeCompany(direction, defaultAddress) {
    if (direction === 'to') {
      this.props.setValue('companyTo', '');
      this.props.setValue('companyToId', '');
      this.props.setValue('addressToId', '');
      this.props.setValue('addressTo', '');
      return;
    }
    if (direction === 'from') {
      this.props.setValue('companyFrom', '');
      this.props.setValue('companyFromId', '');
      this.props.setValue('addressFromId', '');
      this.props.setValue('addressFrom', '');
      return;
    }
    return;
  }

  get vehiclePropertyNames() {
    return Object.keys(this.props.vehicleValues);
  }

  get vehicleDoneTransportProp() {
    const type = this.props.values.type;
    const individual = this.props.values?.individual;

    let prop = 'transport_individual_done';

    if (type == 'incoming') {
      prop = 'transport_done';
    }
    if (type == 'outgoing' && individual != '1') {
      prop = 'transport_outgoing_done';
    }


    return prop;
  }

  get vehiclePlanTransportProp() {
    const type = this.props.values.type;

    let prop = 'transport_individual_initiated';

    if (type == 'incoming') {
      prop = 'transport_initiated';
    }
    if (type == 'outgoing') {
      prop = 'transport_outgoing_initiated';
    }

    return prop;
  }

  get vehicleIncomingTransportDto() {
    const isNl = this.props.values?.companyFrom?.company_from_eu === 'NL' ? '1' : '0';
    let date_done = new Date().toISOString();

    const dto = [
      { propertyName: 'transport_requested', propertyValue: '1' },
      { propertyName: 'transport_is_nl', propertyValue: isNl },
      { propertyName: 'transport_incoming_to_be_planned_date', propertyValue: date_done },
    ];

    if (dto.addressFromId) {
      dto.push({ propertyName: 'transport_from_address_id', propertyValue: dto.addressFromId });
    }
    if (dto.addressToId) {
      dto.push({ propertyName: 'transport_to_address_id', propertyValue: dto?.addressToId });
    }
    if (dto.companyFromId) {
      dto.push({ propertyName: 'transport_incoming_from_company_id', propertyValue: dto.companyFromId });
    }
    if (dto.companyToId) {
      dto.push({ propertyName: 'transport_incoming_to_company_id', propertyValue: dto.companyToId });
    }
    if (this.props.values?.companyFrom?.name) {
      dto.push({
        propertyName: 'transport_incoming_from_company_name',
        propertyValue: this.props.values?.companyFrom?.name,
      });
    }
    if (this.props.values?.companyTo?.name) {
      dto.push({ propertyName: 'transport_incoming_to_company_name', propertyValue: this.props.values?.companyTo?.name });
    }

    return dto;
  }

  save(options = {}) {
    const today = dayjs().format('YYYY-MM-DD hh:mm:ss');

    let dto = {};

    for (let i in this.props.values) {
      console.log('Processing field:', i, 'Value:', this.props.values[i]);

      // Process TRANSPORT_ORDER_COLUMN_1_FIELD_TYPES
      if ([...TRANSPORT_ORDER_COLUMN_1_FIELD_TYPES].includes(i) && this.props.values[i]) {
        dto[i] = this.props.values?.[i];
      }

      // Process TRANSPORT_ORDER_COLUMN_2_FIELD_TYPES
      if ([...TRANSPORT_ORDER_COLUMN_2_FIELD_TYPES].includes(i) && this.props.values[i]) {
        dto[i] = this.props.values?.[i];
        if (i === 'companyFromId' && !this.props.values?.companyFromManual) {
          dto[i] = this.props.values?.[i];
          dto.companyFromManual = null;
        }
        if (i === 'companyToId' && !this.props.values?.companyToManual) {
          dto[i] = this.props.values?.[i];
          dto.companyToManual = null;
        }
        if (i === 'addressFromId' && !this.props.values?.addressFromManual) {
          dto[i] = this.props.values?.[i];
          dto.addressFromManual = null;
        }
        if (i === 'addressToId' && !this.props.values?.addressToManual) {
          dto[i] = this.props.values?.[i];
          dto.addressToManual = null;
        }
      }

      // Handle manual fields
      if (
        ['companyFromManual', 'companyToManual', 'addressFromManual', 'addressToManual', 'vehicleManual'].includes(i) &&
        this.props.values[i]
      ) {
        switch (i) {
          case 'companyFromManual':
            dto[i] = this.props.values?.[i];
            delete dto?.companyFromId;
            break;
          case 'companyToManual':
            dto[i] = this.props.values?.[i];
            delete dto?.companyToId;
            break;
          case 'addressFromManual':
            dto[i] = this.props.values?.[i];
            delete dto?.addressFromId;
            break;
          case 'addressToManual':
            dto[i] = this.props.values?.[i];
            delete dto?.addressToId;
            break;
          case 'vehicleManual':
            dto[i] = this.props.values?.[i];
            delete dto?.vehicleId;
            break;
        }
      }
    }
    console.log(this.props.from_location + 'from_location');
    if (
      !this.props.transportOrderId &&
      (this.props.from_location == 'vehicle_detail' ||
        this.props.from_location == 'overview' ||
        this.props.from_location == 'new_transport')
    ) {
      console.log('Creating new transport order');
      dto.individual = '1';
    }
    if (dto?.vehicleId) {
      dto.vehicleId = +this.props.values?.vehicleId;
    }

    if (options.plan) {
      dto.status = TRANSPORT_ORDER_STATUS.Initiated;
      dto.scheduledDate = today;
      dto.datePlanned = this.props.values?.datePlanned;
    }

    if (options.done) {
      dto.status = TRANSPORT_ORDER_STATUS.Done;
      dto.dateDone = today;
    }

    if (options.requested) {
      dto.status = TRANSPORT_ORDER_STATUS.Requested;
      dto.dateDone = null;
      dto.datePlanned = null;
      dto.transporterId = null;
    }

    // Final DTO log before sending to the backend

    if (this.props.transportOrderId) {
      dto.id = this.props.transportOrderId;
      this.props.edit(dto, result => {
        if (result?.id) {
          if (options.done) {
            this.props.setVehicleProperty(VEHICLE_EXTRA_COST[result?.type], parseFloat(121));
            this.props.setVehicleProperty(this.vehicleDoneTransportProp, '1');
          }
          if (options.plan) {
            this.props.setVehicleProperty(this.vehiclePlanTransportProp, '1');
          }
          // Vehicle location is now updated atomically by the backend
          this.props.setTransportOrderFilter();
          this.reset();
        }
      });
      return;
    }

    if (this.props.vehicleIds) {
      this.props.createTransportBulkAction(dto, result => {
        if (result?.length) {
          this.reset();
        } else {
          console.error('Error:', result); // Inspect the result to identify the exact problem
        }
      });

      return;
    }

    if (this.props.addVehicleModal) {
      const vehicleDto = this.vehicleIncomingTransportDto;

      this.props.create(dto, result => {
        if (result?.id) {
          this.props.setVehicleTransportProps(vehicleDto, () => {
            this.reset();
          });
        } else {
          console.error('Error:', result); // Inspect the result to identify the exact problem
        }
      });

      return;
    }

    // Proceed with the API call or further processing
    dto.status = TRANSPORT_ORDER_STATUS.Requested;
    this.props.create(dto, result => {
      if (result?.id) {
        this.props.setTransportOrderFilter();
        this.reset();
      } else {
        console.error('Error:', result); // Inspect the result to identify the exact problem
      }
    });
  }

  applyDisabled() {
    if (
      (!this.props.values?.addressFromId && !this.props.values.addressFromManual) ||
      (!this.props.values?.addressToId && !this.props.values.addressToManual) ||
      ((this.props.from_location == 'vehicle_detail' || this.props.from_location == 'new_transport') &&
        !this.props.values?.dateToPlan)
    )
      return true;

    return false;
  }

  reset() {
    this.props.init();
    return this.props.onClose();
  }

  render() {
    let modalSize = 'modal-xl';
    {
      this.props.from_location === 'overview' && (modalSize = 'modal-l');
      this.state.modaltype == 'edit' && (modalSize = 'modal-xl');
    }
    if (this.props.work) {
      return (
        <ModalComponent size="modal-xl">
          <HBox gap={12}>
            <VBox>
              <LoadingField />
              <LoadingField />
              <LoadingField />
            </VBox>
            <VBox>
              <LoadingField />
              <LoadingField />
              <LoadingField />
            </VBox>
          </HBox>
        </ModalComponent>
      );
    }
    return (
      <ModalComponent size={modalSize} onClose={() => this.reset()}>
        <CreateFieldsColumns
          vehicleId={this.props.vehicle?.id}
          vehicle={this.props.vehicle}
          from_location={this.props.from_location}
          addVehicleModal={this.props.addVehicleModal}
          bulkActionsList={this.props.bulkActionsList}
          setModalToEdit={this.setModalToEdit} // Pass the function as a prop
          saveWithPlanVehicle={() => {
            this.save({ plan: true });
          }}
          saveWithDoneVehicle={() => {
            this.save({ done: true });
          }}
          saveWithResetVehicle={() => {
            this.save({ requested: true });
          }}
        />
        <div className="d-flex gap-2 justify-content-end mt-3">
          {(this.props.from_location != 'overview' || this.state.modaltype == 'edit') && (
            <>
              <ButtonComponent disabled={this.applyDisabled()} style="ButtonSoftEdit" onClick={() => this.save()}>
                {this.props.transportOrderId ? this.lbl('edit') : this.lbl('save')}
              </ButtonComponent>
              <ButtonComponent style="ButtonSoftDelete" onClick={() => this.reset()}>
                {this.lbl('cancel')}
              </ButtonComponent>
            </>
          )}
        </div>
      </ModalComponent>
    );
  }
}

CreateTransportOrderModalComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
  onClose: PropTypes.func,
  reset: PropTypes.func,
  onNextModal: PropTypes.func,
  modalSize: PropTypes.string.isRequired,
  setModalToEdit: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([
      REQUEST_TRANSPORT_ORDER_CREATE,
      REQUEST_TRANSPORT_ORDER_EDIT,
      REQUEST_CREATE_TRANSPORT_ORDER_BULK_ACTION,
      REQUEST_TRANSPORT_ORDER,
      REQUEST_TRANSPORTER_PROPERTY_UPDATE + '-' + 'deleteTransporter',
    ]),
    transporters: selectTransporters(),
    workTransporters: selectWorks([REQUEST_TRANSPORTERS]),
    values: selectNewTransportOrder(),
    vehicleValues: selectNewVehicle(),
    homeCompany: selectCompany(4),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    initEdit() {
      dispatch(initiateTransportOrderEdit(ownProps.transportOrderId));
    },
    init() {
      dispatch(initiateTransportOrderCreate());
    },
    fetchTransportOrder(callback) {
      dispatch(fetchTransportOrder(ownProps.transportOrderId, callback));
    },
    create(dto, callback) {
      dispatch(createTransportOrder(dto, callback));
    },
    createTransportBulkAction(dto, callback) {
      dispatch(createTransportOrderBulkAction(ownProps.vehicleIds, dto, callback));
    },
    edit(dto, callback) {
      dispatch(editTransportOrder(ownProps.transportOrderId, dto, callback));
    },
    setTransportOrderFilter: () => {
      dispatch(applyTransportOrderFilters());
    },
    setValue(name, value) {
      dispatch(setNewTransportOrderValue(name, value));
    },
    fetchTransporters(callback) {
      dispatch(fetchTransporters(callback, 99999));
    },
    createTransporter() {
      dispatch(createTransporter());
    },
    fetchVehicles() {
      dispatch(fetchVehicles());
    },
    setVehicleTransportProps(properties, callback) {
      dispatch(setVehicleProperties(ownProps.vehicleId, properties, callback));
    },
    setVehicleProperty(name, value, callback) {
      ownProps.vehicleId && dispatch(setVehicleProperty(ownProps.vehicleId, name, value, callback));
    },
    fetchCompany(callback) {
      dispatch(fetchCompany(4, callback));
    },
    resetVehicleValues(values, name = null) {
      values.map(type => dispatch(setNewVehicleValue(type, '')));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const CreateTransportOrderModal = compose(withConnect, withRouter, injectIntl)(CreateTransportOrderModalComp);
